import { Attendance, LeaveRequest } from '@/types/employee/attendance';
import dayjs from 'dayjs';

const employeeNames = [
  'Mike Johnson', 'Sarah Wilson', 'David Brown', 'Lisa Davis', 'Robert Miller',
  'Jennifer Garcia', 'William Rodriguez', 'Maria Martinez', 'James Anderson', 'Patricia Taylor',
  'John Thomas', 'Linda Jackson', 'Michael White', 'Barbara Harris', 'Richard Martin',
  'Elizabeth Thompson', 'Joseph Garcia', 'Jennifer Martinez', 'Christopher Robinson', 'Jessica Clark',
  'Daniel Rodriguez', 'Amanda Lewis', 'Matthew Lee', 'Melissa Walker', 'Anthony Hall',
  'Stephanie Young', 'Mark Allen', 'Nicole King', 'Donald Wright', 'Helen Lopez',
  'Steven Hill', 'Sandra Scott', 'Paul Green', 'Donna Baker', 'Andrew Adams',
  'Carol Nelson', 'Joshua Carter', 'Ruth Mitchell', 'Ryan Perez', 'Deborah Roberts',
  'Gary Turner', 'Sharon Phillips', 'Timothy Campbell', 'Cynthia Parker', 'Jose Evans',
  'Katherine Edwards', 'Larry Collins', 'Nancy Stewart', 'Jeffrey Sanchez', 'Betty Morris'
];

const attendanceStatuses = ['Present', 'Absent', 'Late', 'On Leave', 'Half Day'];

export const attendances: Attendance[] = Array.from({ length: 30 }, (_, idx) => {
  const employeeIndex = idx % employeeNames.length;
  const statusIndex = idx % attendanceStatuses.length;
  const day = (idx % 28) + 1; // 1-28
  const month = (idx % 12) + 1; // 1-12
  const year = 2024;
  
  const checkInTime = dayjs().year(year).month(month - 1).date(day).hour(8 + Math.floor(Math.random() * 2)).minute(Math.floor(Math.random() * 60));
  const checkOutTime = dayjs().year(year).month(month - 1).date(day).hour(17 + Math.floor(Math.random() * 2)).minute(Math.floor(Math.random() * 60));
  
  return {
    id: `ATT${(idx + 1).toString().padStart(3, '0')}`,
    employee: [
      {
        id: `EMP${(employeeIndex + 1).toString().padStart(3, '0')}`,
        name: employeeNames[employeeIndex],
        checkInTime: attendanceStatuses[statusIndex] === 'Absent' ? undefined : checkInTime,
        checkOutTime: attendanceStatuses[statusIndex] === 'Absent' ? undefined : checkOutTime,
        status: attendanceStatuses[statusIndex] as any
      }
    ],
    day,
    month,
    year,
    notes: `Attendance record for ${employeeNames[employeeIndex]} on ${day}/${month}/${year}`
  };
});

export const leaveRequests: LeaveRequest[] = Array.from({ length: 20 }, (_, idx) => {
  const employeeIndex = idx % employeeNames.length;
  const leaveTypes = ['Annual', 'Sick', 'Unpaid', 'Other'];
  const leaveStatuses = ['pending', 'approved', 'rejected'];
  
  const startDate = dayjs().add(Math.floor(Math.random() * 30), 'days').toDate();
  const endDate = dayjs(startDate).add(Math.floor(Math.random() * 7) + 1, 'days').toDate();
  
  return {
    id: `LEAVE${(idx + 1).toString().padStart(3, '0')}`,
    employee: {
      id: `EMP${(employeeIndex + 1).toString().padStart(3, '0')}`,
      name: employeeNames[employeeIndex]
    },
    startDate,
    endDate,
    type: leaveTypes[idx % leaveTypes.length] as any,
    status: leaveStatuses[idx % leaveStatuses.length] as any,
    reason: `Leave request for ${employeeNames[employeeIndex]} - ${leaveTypes[idx % leaveTypes.length]} leave`,
    approvedBy: leaveStatuses[idx % leaveStatuses.length] === 'approved' ? {
      id: 'ADM001',
      name: 'Admin User'
    } : undefined,
    approvedAt: leaveStatuses[idx % leaveStatuses.length] === 'approved' ? dayjs().subtract(Math.floor(Math.random() * 10), 'days').toDate() : undefined
  };
}); 